import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1500;
  inset: 0;
  background: rgba(33, 41, 52, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const Modal = styled.div`
  width: ${({ $withDocument }) => ($withDocument ? "min(1360px, 96vw)" : "min(860px, 100%)")};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.22);
  position: relative;
  padding: 28px;
  font-family: "Manrope", sans-serif;
`;

export const ModalBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const DetailPane = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding-right: 4px;
`;

export const DocumentPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 320px;
  border-left: 1px solid #e5eaf0;
  padding-left: 24px;

  @media (max-width: 900px) {
    border-left: none;
    border-top: 1px solid #e5eaf0;
    padding-left: 0;
    padding-top: 16px;
    height: 480px;
  }
`;

export const DocumentPaneToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

export const DocumentPaneBody = styled.div`
  flex: 1;
  min-height: 0;
  border: 1px solid #e5eaf0;
  border-radius: 8px;
  overflow: hidden;
`;

export const HideDocumentButton = styled.button`
  background: none;
  border: none;
  color: #7d8999;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 0;
`;

export const ViewDocumentLink = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: #0c53bb;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 4px;
  margin-top: 6px;
  padding: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 18px;
  top: 18px;
  background: none;
  border: none;
  color: #7d8999;
  cursor: pointer;
  padding: 4px;
`;

export const Title = styled.h2`
  color: #1b2028;
  font-size: 22px;
  line-height: 30px;
  margin: 0 42px 24px 0;
`;

export const Section = styled.section`
  border-top: 1px solid #e5eaf0;
  padding: 20px 0 4px;
`;

export const SectionTitle = styled.h3`
  color: #26364d;
  font-size: 15px;
  margin: 0 0 14px;
`;

export const EvidenceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const EvidenceLabel = styled.div`
  color: #718096;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

export const EvidenceValue = styled.div`
  color: #29384d;
  font-size: 13px;
  line-height: 20px;
  overflow-wrap: anywhere;
`;

export const HashValue = styled(EvidenceValue)`
  color: #123f78;
  font-family: "Roboto Mono", monospace;
  font-size: 12px;
`;

export const ConfirmationValue = styled(HashValue)`
  font-size: 15px;
  font-weight: 800;
`;

export const IntegrityBadge = styled.span`
  background: ${({ valid }) => (valid ? "#e4f5eb" : "#fde9e7")};
  border-radius: 999px;
  color: ${({ valid }) => (valid ? "#17653b" : "#a32b26")};
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
`;

export const EventList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EventCard = styled.article`
  background: #f7f9fb;
  border: 1px solid #e5eaf0;
  border-radius: 8px;
  padding: 12px 14px;

  details {
    margin-top: 8px;
  }

  summary {
    color: #0c53bb;
    cursor: pointer;
    font-size: 12px;
  }

  pre {
    background: #eef2f7;
    border-radius: 6px;
    color: #29384d;
    font-family: "Roboto Mono", monospace;
    font-size: 11px;
    margin: 8px 0 0;
    max-height: 180px;
    overflow: auto;
    padding: 10px;
    white-space: pre-wrap;
  }
`;

export const EventHeader = styled.div`
  align-items: baseline;
  color: #26364d;
  display: flex;
  font-size: 13px;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 6px;

  span {
    color: #718096;
    font-size: 11px;
    white-space: nowrap;
  }

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
`;
